@if (visible()) {
  <nav class="mobile-tab-bar" aria-label="Primary">
    <a routerLink="/question-pool" routerLinkActive="active" class="mobile-tab" aria-label="New test">
      <span class="tab-icon">
        <i class="bi bi-file-earmark-plus icon-outline" aria-hidden="true"></i>
        <i class="bi bi-file-earmark-plus-fill icon-filled" aria-hidden="true"></i>
      </span>
      <span class="tab-label">New</span>
    </a>
    <a routerLink="/saved-tests" routerLinkActive="active" class="mobile-tab" aria-label="Saved tests">
      <span class="tab-icon">
        <i class="bi bi-bookmark icon-outline" aria-hidden="true"></i>
        <i class="bi bi-bookmark-fill icon-filled" aria-hidden="true"></i>
      </span>
      <span class="tab-label">Saved</span>
    </a>
    @if (retentionFlags.studyTogetherEnabled()) {
      <a routerLink="/study-together" routerLinkActive="active" class="mobile-tab" aria-label="Study together">
        <span class="tab-icon">
          <i class="bi bi-people icon-outline" aria-hidden="true"></i>
          <i class="bi bi-people-fill icon-filled" aria-hidden="true"></i>
        </span>
        <span class="tab-label">Together</span>
      </a>
    }
    <a routerLink="/search-question" routerLinkActive="active" class="mobile-tab" aria-label="Search">
      <span class="tab-icon">
        <i class="bi bi-search" aria-hidden="true"></i>
      </span>
      <span class="tab-label">Search</span>
    </a>
  </nav>
}
